import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import React from 'react';import PropTypes from 'prop-types';
import AddHardwareStep1 from './components/AddHardwareStep1';
import AddHardwareStep2 from './components/AddHardwareStep2';
import AddHardwareStep3 from './components/AddHardwareStep3';
import FormContainer from './../../../../components/FormContainer';
import Breadcrumbs from './../../../../components/Breadcrumbs';
import { selectors, actions } from './../../../../../modules/customer/profile/hardwareProducts';
import { selectors as profileSelectors } from './../../../../../modules/customer/profile';
import { actions as formActions } from '../../../../../modules/form';
import { Icon, FormConfirmationScreen } from './../../../../../common/components';

const steps = [
    {
        stepNumber: 1,
        stepTitle: "Serienummer",
        stepBody: <AddHardwareStep1 />,
        isStepValidSelector: selectors.isAddHardwareFormStep1Valid        
    },
    {
        stepNumber: 2,
        stepTitle: "Oppsumering",
        stepBody: <AddHardwareStep2 />,
        isStepValidSelector: selectors.isAddHardwareFormStep2Valid
    },
    // {
    //     stepNumber: 3,
    //     stepTitle: "Oppsumering",
    //     stepBody: <AddHardwareStep3 />,
    //     isStepValidSelector: selectors.isAddHardwareFormStep3Valid
    // }
];

const addHardwareformName ="AddHardwareForm";

const AddHardware = ({confirmationAction, abortAction, customerId }) => (
    <FormContainer
        formName = {addHardwareformName}
        formTitle="Registrer utstyr"
        stepsList={steps}
        confirmStepAction={() => confirmationAction(customerId)}
        onAbortHandler={abortAction}
        showConfirmationScreen={true}
        confirmationScreenBody={<FormConfirmationScreen 
                                     formName = {addHardwareformName}                                     
                                     redirectUrl = {"/customer/" + customerId}
                                     isLoadingSelector = {selectors.addHardwareFormIsLoading}
                                     requestSuccessfulSelector = {selectors.addHardwareRequestSuccessful}
                                />}
    />
);

const mapStateToProps = createStructuredSelector({
    customerId: profileSelectors.getCustomerID,    
})

const mapDispatchToProps = (dispatch, props) => ({
    confirmationAction: (customerId) => {
        dispatch(actions.addHardwareProducts());
        dispatch(actions.fetchHardwareProductsList(customerId));
    },    
    abortAction: (formName) =>  dispatch(formActions.resetForm(formName)).then(() => dispatch(actions.clearHardwareFormData()))    
});

export default connect(mapStateToProps, mapDispatchToProps)(AddHardware);